<template>
	<v-card flat class="">
		<v-data-table :headers="table.headers" :items="table.items" :options.sync="tableOptions"
			:server-items-length="table.totalItems" :loading="table.loading" :search="table.search" class="elevation-1">
			<template v-slot:top>
				<v-toolbar flat>
					<v-toolbar-title>Jadwal Praktik</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-dialog v-model="dialog" max-width="800px">
						<template v-slot:activator="{ on, attrs }">
							<v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on" @click="add()" small>
								Tambah Data
							</v-btn>
							<v-btn small color="secondary" @click="getDataFromApi()" class="mr-4"><v-icon>{{
								icons.mdiMagnify
									}}</v-icon></v-btn>
							<v-text-field v-model="table.search" label="Pencarian (institusi/kelompok)..." outlined
								dense hide-details @keyup.enter="getDataFromApi()"></v-text-field>
							<v-select v-model="table.status" outlined hide-details="" dense
								label="Status :" :items="table.statuss" @change="getDataFromApi()"></v-select>
						</template>
						<v-card>
							<v-card-title>
								<span class="text-h6">{{ formTitle }}</span>
							</v-card-title>
							<v-card-text>
								<v-row>
									<v-col cols="12" sm="6" md="6">
										<v-autocomplete v-model="form.editedItem.id_institusi"
											:items="institusi_pendidikans" outlined dense
											label="* Institusi Pendidikan :" item-text="nama" item-value="id"
											hide-details=""></v-autocomplete>
									</v-col>
									<v-col cols="12" sm="6" md="6">
										<v-autocomplete v-model="form.editedItem.id_prodi" :items="prodis" outlined
											dense label="* Prodi :" item-text="nama" item-value="id"
											hide-details=""></v-autocomplete>
									</v-col>
									<v-col cols="12" sm="6" md="6">
										<v-select v-model="form.editedItem.profesi" outlined hide-details="" dense
											label="* Kelompok :" :items="form.profesis" class="mb-3"></v-select>
									</v-col>
									<v-col cols="12" sm="6" md="6">
										<v-autocomplete v-model="form.editedItem.stase_id" :items="form.stases" outlined
											dense hide-details="" label="Stase :" item-text="text"
											item-value="id"></v-autocomplete>
									</v-col>
									<v-col cols="12">
										<v-text-field v-model="form.editedItem.nama" outlined dense hide-details=""
											label="Nama / Keterangan :"></v-text-field>
									</v-col>
									<v-col v-if="form.editedItem.file_url != null" cols="12" sm="6" md="6">
										<label>File Jadwal:</label><br />
										<a target="_blank" :href="form.editedItem.file_url">Lihat
											File Terupload</a>
										<br /><br /><span>Pilih file baru untuk edit file</span>
										<input type="file" label="Pilih File" accept="application/pdf" ref="file"
											@change="onFileChange()" />
									</v-col>
									<v-col v-else cols="12" sm="6" md="6">
										<label>* File Jadwal:</label><br />
										<input type="file" label="Pilih File" accept="application/pdf" ref="file"
											@change="onFileChange()" />
									</v-col>

									<v-col v-if="form.editedItem.file_spt_url != null" cols="12" sm="6" md="6">
										<label>File SPT:</label><br />
										<a target="_blank" :href="form.editedItem.file_spt_url">Lihat
											File Terupload</a>
										<br /><br /><span>Pilih file baru untuk edit file</span>
										<input type="file" label="Pilih File" accept="application/pdf" ref="file_spt"
											@change="onFileSPTChange()" />
									</v-col>
									<v-col v-else cols="12" sm="6" md="6">
										<label>* File SPT:</label><br />
										<input type="file" label="Pilih File" accept="application/pdf" ref="file_spt"
											@change="onFileSPTChange()" />
									</v-col>

									<v-col cols="12" sm="6" md="6">
										<v-text-field v-model="form.editedItem.tanggal_awal" type="date" outlined
											label="Tanggal Awal :" hide-details=""></v-text-field>
									</v-col>
									<v-col cols="12" sm="6" md="6">
										<v-text-field v-model="form.editedItem.tanggal_akhir" type="date" outlined
											label="Tanggal Akhir :" hide-details=""></v-text-field>
									</v-col>
									<v-col cols="12">
										<v-text-field v-model="form.editedItem.total_hari" outlined dense hide-details=""
											label="Total Hari :"></v-text-field>
									</v-col>
								</v-row>
								<!-- </v-container> -->
							</v-card-text>
							<v-card-actions>
								<v-btn color="primary" @click="save()" small>
									Simpan
								</v-btn>
								<v-btn color="error" v-if="form.editedItem.flag_end == 0" @click="switchKeaktifan(0)"
									small>
									Non Aktifkan
								</v-btn>
								<v-btn color="success" v-if="form.editedItem.flag_end == 1" @click="switchKeaktifan(1)"
									small>
									Aktifkan
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-toolbar>
			</template>
			<template v-slot:item.institusi="{ item }">
				{{ item.nama_institusi }}/ {{ item.nama_prodi }}
			</template>
			<template v-slot:item.stase="{ item }">
				{{ item.nama_stase }}, {{ item.stase }}
			</template>
			<template v-slot:item.file_url="{ item }">
				<embed type="application/pdf" :src="item.file_url + '#toolbar=0&navpanes=0&scrollbar=0'" width="500"
					height="300" />
				<br /><a target="_blank" :href="item.file_url">Lihat
					File</a>
			</template>
			<template v-slot:item.actions="{ item }">
				<span v-if="item.flag_end == 0">Aktif</span>
				<span v-else>Non Aktif</span><br /><br />
				<v-icon v-if="item.flag_end == 0" small class="mr-2" @click="editItem(item)" title="Edit">
					{{ icons.mdiPencil }}
				</v-icon>
				<router-link v-if="item.flag_end == 0" :to="{ name: 'AdminPraktikAnggota', params: { id: item.id } }"
					title="Lihat Siswa dan Pembimbing Praktik">
					<v-icon small>
						{{ icons.mdiEye }}
					</v-icon>
				</router-link>
			</template>
			<template v-slot:no-data>
				<v-btn color="primary" @click="getDataFromApi" x-small>
					Reload
				</v-btn>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import { mdiEye, mdiPencil, mdiMagnify } from '@mdi/js'

export default {
	components: {
	},
	data: () => ({
		icons: {
			mdiEye,
			mdiPencil,
			mdiMagnify
		},
		tableOptions: {},
		table: {
			loading: true,
			headers: [
				{ text: 'No', align: 'start', sortable: false, value: 'no' },
				{ text: 'Institusi', value: 'institusi', sortable: false },
				{ text: 'Kelompok', value: 'profesi', sortable: false },
				{ text: 'Stase', value: 'stase', sortable: false },
				{ text: 'File', value: 'file_url', sortable: false },
				{ text: 'Status/ Aksi', value: 'actions', sortable: false },
			],
			items: [],
			totalItems: 0,
			search: '',
			status: 'Aktif',
			statuss: ['Aktif', 'Non Aktif']
		},
		dialog: false,
		// dialogDelete: false,
		form: {
			editedIndex: -1,
			file_temp: '',
			file_spt_temp: '',
			editedItem: {
				id_institusi: '',
				id_prodi: '',
				nama: '',
				profesi: '',
				stase_id: 0,
				tanggal_awal: '',
				tanggal_akhir: '',
				total_hari:0,
			},
			defaultItem: {
				id_prodi: '',
				id_prodi: '',
				nama: '',
				profesi: '',
				stase_id: 0,
				tanggal_awal: '',
				tanggal_akhir: '',
				total_hari:0,
			},
			profesis: [
				'Dokter',
				'PPDS',
				'Keperawatan,Kebidanan, dan Tenaga Kesehatan Lain',
			],
			stases: [],
		},
		institusi_pendidikans: [],
		prodis: [],
	}),
	watch: {
		tableOptions: {
			handler() {
				this.getDataFromApi()
			},
			deep: true,
		},
	},
	computed: {
		formTitle() {
			return this.form.editedIndex === -1 ? 'Tambah Data' : 'Edit Data'
		},
	},
	created() {
		this.getStase()
		this.getInstitusiPendidikan()
		this.getProdi()
	},
	methods: {
		onFileChange() {
			this.form.file_temp = this.$refs.file.files.item(0)
			// this.form.editedItem.previewImage = URL.createObjectURL(this.form.editedItem.foto)
		},
		onFileSPTChange() {
			this.form.file_spt_temp = this.$refs.file_spt.files.item(0)
		},
		getInstitusiPendidikan() {
			axiosGetAuth('api/RegisterLanjutan/getInstitusiPendidikans')
				.then(response => {
					if (response.code === 200) {
						this.institusi_pendidikans = response.datas
					} else {
						alert(response.message)
					}
				})
				.catch(error => {
					alert(error)
				})
		},
		getProdi() {
			axiosGetAuth('api/RegisterLanjutan/getProdis')
				.then(response => {
					if (response.code === 200) {
						this.prodis = response.datas
					} else {
						alert(response.message)
					}
				})
				.catch(error => {
					alert(error)
				})
		},
		getStase() {
			axiosGetAuth('api/Praktik/getStase')
				.then(response => {
					this.form.stases = response.data
				})
				.catch(error => {
					alert(error)
				})
		},
		save() {
			if (this.form.editedIndex > -1) {
				const fmData = new FormData()
				fmData.append('id', this.form.editedItem.id)
				fmData.append('nama', this.form.editedItem.nama)
				fmData.append('id_institusi', this.form.editedItem.id_institusi)
				fmData.append('id_prodi', this.form.editedItem.id_prodi)
				fmData.append('profesi', this.form.editedItem.profesi)
				fmData.append('stase_id', this.form.editedItem.stase_id)
				fmData.append('file_name', this.form.editedItem.file_name)
				if (this.form.file_temp != undefined) {
					fmData.append('file', this.form.file_temp)
				}
				if (this.form.file_spt_temp != undefined) {
					fmData.append('file_spt', this.form.file_spt_temp)
				}
				fmData.append('tanggal_awal', this.form.editedItem.tanggal_awal)
				fmData.append('tanggal_akhir', this.form.editedItem.tanggal_akhir)
				fmData.append('total_hari', this.form.editedItem.total_hari)
				axiosPostAuth('api/Praktik/updatePraktik', fmData)
					.then(response => {
						if (response.code === 200) {
							alert(response.message)
							this.dialog = false
							this.getDataFromApi()
						}
						else {
							alert(response.message)
						}
					})
					.catch(error => {
						alert(error)
					})
			} else {
				const fmData = new FormData()
				fmData.append('nama', this.form.editedItem.nama)
				fmData.append('id_institusi', this.form.editedItem.id_institusi)
				fmData.append('id_prodi', this.form.editedItem.id_prodi)
				fmData.append('profesi', this.form.editedItem.profesi)
				fmData.append('stase_id', this.form.editedItem.stase_id)
				fmData.append('tanggal_awal', this.form.editedItem.tanggal_awal)
				fmData.append('tanggal_akhir', this.form.editedItem.tanggal_akhir)
				if (this.form.file_temp != undefined) {
					fmData.append('file', this.form.file_temp)
				}
				if (this.form.file_spt_temp != undefined) {
					fmData.append('file_spt', this.form.file_spt_temp)
				}
				fmData.append('total_hari', this.form.editedItem.total_hari)
				axiosPostAuth('api/Praktik/addPraktik', fmData)
					.then(response => {
						if (response.code === 200) {
							alert(response.message)
							this.getDataFromApi()
						}
						else {
							alert(response.message)
						}
					})
					.catch(error => {
						alert(error)
					})
			}
		},
		getDataFromApi() {
			const { page, itemsPerPage } = this.tableOptions
			const fmData = new FormData()
			fmData.append('page', page)
			fmData.append('itemsPerPage', itemsPerPage)
			fmData.append('search', this.table.search)
			fmData.append('status', this.table.status)
			axiosPostAuth('api/Praktik/getPraktik_datatable', fmData)
				.then(response => {
					this.table.items = response.data
					this.table.totalItems = response.total
					this.table.loading = false
				})
				.catch(error => {
					alert(error)
				})
		},
		add() {
			this.form.editedItem = Object.assign({}, this.form.defaultItem)
			this.form.editedIndex = -1
		},
		editItem(item) {
			this.form.editedIndex = this.table.items.indexOf(item)
			this.form.editedItem = Object.assign({}, item)
			this.dialog = true
		},
		switchKeaktifan(flag_end) {
			let conf = true
			if (flag_end == 0) {
				conf = confirm("Apakah yakin akan menonaktifkan?")
			} else {
				conf = confirm("Apakah yakin akan mengaktifkan?")
			}
			if (conf) {
				const fmData = new FormData()
				fmData.append('id', this.form.editedItem.id)
				fmData.append('flag_end', this.form.editedItem.flag_end)
				axiosPostAuth('api/Praktik/updateStatus', fmData)
					.then(response => {
						this.getDataFromApi()
						this.dialog = false
					})
					.catch(error => {
						alert(error)
					})
			}
		},
	},
}
</script>